import { getRecordingList } from 'services/api/recordings/list';
import { getRecordingAdd } from 'services/api/recordings/add';
import { getRecordingDelete } from 'services/api/recordings/delete';
import { getRecordingSerieDelete } from 'services/api/recordings/deleteserie';
import { getRecordingAddSerie } from 'services/api/recordings/addserie';
import { getSerieRecordingList } from 'services/api/recordings/listserie';
import {
  NPVR_FETCH_EVENT_LIST_INIT,
  NPVR_FETCH_EVENT_LIST_SUCCESS,
  NPVR_FETCH_EVENT_LIST_ERROR,
  NPVR_ADD_EVENT_INIT,
  NPVR_ADD_EVENT_SUCCESS,
  NPVR_ADD_EVENT_ERROR,
  NPVR_ADD_SERIE_INIT,
  NPVR_ADD_SERIE_SUCCESS,
  NPVR_ADD_SERIE_ERROR,
  NPVR_DELETE_EVENT_INIT,
  NPVR_DELETE_EVENT_SUCCESS,
  NPVR_DELETE_EVENT_ERROR,
  NPVR_FETCH_SERIES_LIST_INIT,
  NPVR_FETCH_SERIES_LIST_SUCCESS,
  NPVR_FETCH_SERIES_LIST_CLEAR,
  NPVR_DELETE_SERIE_INIT,
  NPVR_DELETE_SERIE_SUCCESS,
  NPVR_DELETE_SERIE_ERROR,
  NPVR_DELETE_SERIE_CLEAR,
} from './constants';

export const fetchRecordingList = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: NPVR_FETCH_EVENT_LIST_INIT,
    });
    dispatch({ type: NPVR_FETCH_SERIES_LIST_CLEAR });

    const fetch = await getRecordingList(params);

    if (fetch?.response?.series && fetch?.response?.series?.length > 0) {
      dispatch({
        type: NPVR_FETCH_SERIES_LIST_INIT,
      });

      const fetchResults = [];
      const userSeriesId = {};
      // eslint-disable-next-line no-restricted-syntax
      for (const serie of fetch.response?.series) {
        fetchResults.push(getSerieRecordingList(serie?.actions?.episodes));
        userSeriesId[serie.serie_id] = serie?.user_serie_id;
      }

      const records = await Promise.all(fetchResults).catch(e => {
        console.log('****Error', e);
      });

      let rec = [];
      rec = records
        .filter(r => r.response)
        .map(r =>
          r?.response?.recordings?.map(record => ({
            ...record,
            userSerieId: userSeriesId?.[record?.channel?.event?.ext_series_id],
          })),
        );
      dispatch({
        type: NPVR_FETCH_SERIES_LIST_SUCCESS,
        payload: rec.flat(),
      });
    }
    dispatch({ type: NPVR_FETCH_EVENT_LIST_SUCCESS, payload: fetch?.response });
  } catch (e) {
    console.log('error===>', e);
    dispatch({ type: NPVR_FETCH_EVENT_LIST_ERROR, error: e });
  }
};

export const addRecording = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: NPVR_ADD_EVENT_INIT,
    });
    const data = await getRecordingAdd(params);
    if (data.response) {
      dispatch({ type: NPVR_ADD_EVENT_SUCCESS, payload: data?.response });
      dispatch(fetchRecordingList({ user_token: params?.user_token }));
    } else {
      dispatch({ type: NPVR_ADD_EVENT_ERROR, error: data?.errors?.[0] });
      throw new Error(data?.errors?.[0]?.code);
    }
  } catch (e) {
    console.log('error===>', e);
  }
};

export const addSerieRecording = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: NPVR_ADD_SERIE_INIT,
    });
    const data = await getRecordingAddSerie(params);
    if (data.response) {
      dispatch({ type: NPVR_ADD_SERIE_SUCCESS, payload: data?.response });
      dispatch(fetchRecordingList({ user_token: params?.user_token }));
    } else {
      dispatch({ type: NPVR_ADD_SERIE_ERROR, error: data?.errors?.[0] });
      throw new Error(data?.errors?.[0]?.code);
    }
  } catch (e) {
    console.log('error===>', e);
  }
};

export const deleteRecording = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: NPVR_DELETE_EVENT_INIT,
    });
    const data = await getRecordingDelete(params);
    if (data.response) {
      dispatch({ type: NPVR_DELETE_EVENT_SUCCESS, payload: data?.response });
      dispatch(fetchRecordingList({ user_token: params?.user_token }));
    } else {
      dispatch({ type: NPVR_DELETE_EVENT_ERROR, error: data?.errors?.[0] });
      throw new Error(data?.errors?.[0]?.code);
    }
  } catch (e) {
    console.log('error===>', e);
  }
};

export const deleteSerieRecording = (params = {}) => async dispatch => {
  try {
    dispatch({
      type: NPVR_DELETE_SERIE_INIT,
    });
    const data = await getRecordingSerieDelete(params);
    if (data.response) {
      dispatch({ type: NPVR_DELETE_SERIE_SUCCESS, payload: data?.response });
      dispatch(fetchRecordingList({ user_token: params?.user_token }));
    } else {
      dispatch({ type: NPVR_DELETE_SERIE_ERROR, error: data?.errors?.[0] });
      throw new Error(data?.errors?.[0]?.code);
    }
  } catch (e) {
    console.log('error===>', e);
  }
};
